/** Odoo ERP adapter — STUB. Implements ERPPort. */
export function createOdooERP() {
  const err = () => { throw new Error("ODOO_ERP_NOT_IMPLEMENTED"); };
  return {
    async status() { return { status: "not_connected", vendor: "odoo" }; },
    async listInvoicesForActor() { err(); },
    async listCatalog() { err(); },
    async createQuote() { err(); },
    async createOrder() { err(); },
  };
}
